module.exports = __webpack_public_path__ + "static/media/garagecafe.20ed6fba.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/garagecafe.png
// module id = 51
// module chunks = 0